import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance"

export const deleteSavedBills = (merchantId: string) => {
  return axiosPrivate.delete(`/bills/api/v1/saved-bills/?id=${merchantId}`)
}